
import React, {Component} from 'react';
import {BrowserRouter} from 'react-router-dom';
import $ from 'jquery';
import axios from 'axios';
import {API_ROOT} from './api-config';
import SockJS from 'sockjs-client'
import Geolocation from '@react-native-community/geolocation';
import Cookies from 'js-cookie';

// App Routes
import Routes from './Routes';

// Vendor dependencies
import "./Vendor";
// Application Styles
import './styles/bootstrap.scss';
import './styles/app.scss'
import Swal from "sweetalert2";

// Disable warning "Synchronous XMLHttpRequest on the main thread is deprecated.."
$.ajaxPrefilter(o => o.async = true);

class App extends Component {
    //login
    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: false,
            isAuthenticating: true,
            first_name: '',
            last_name: '',
            role_id: '',
            num_unread: null,
            num_unread_maint: null,
            last_updated_thread: 0,
            last_updated_hash: 0,
            isConnected: false,
            messages: {
                list: [],
                loading: true,
                subscribed: []
            },
            messages_maint: {
                list: [],
                loading: true,
            },
        };
        this.refresh_from_local = this.refresh_from_local.bind(this)
    }

    async loadDriverProfile() {
        try {
            axios.defaults.withCredentials = true;
            const me = await axios.get(`${API_ROOT}/driver/me`, {withCredentials: true});
            if (me && me.status === 200 && me.data) {
                const {first_name = '', last_name = ''} = me.data;
                try {
                    localStorage.setItem('first_name', first_name);
                    localStorage.setItem('last_name', last_name);
                } catch (e) {
                }
                this.setState({first_name, last_name});
            }
        } catch (e) {
            // ignore
        }
    }

    async componentDidMount() {
        this.userHasAuthenticated(false);
        var self = this;
        self.refresh_from_local(); // trigger immediate reload from local storage

        // Fallback: if URL contains a magic link code (from redirect), finalize auth via API
        try {
            const params = new URLSearchParams(window.location.search || '');
            const codeParam = params.get('code') || params.get('auth');
            if (codeParam && codeParam.length === 8) {
                axios.defaults.withCredentials = true;
                const resp = await axios.post(`${API_ROOT}/driver/auth`, {code: codeParam}, {withCredentials: true});
                if (resp && resp.status === 200) {
                    this.userHasAuthenticated(true);
                    await this.loadDriverProfile();
                    this.setState({isAuthenticating: false});
                    return;
                }
            }
            // Fallback 2a: if path is /driver/auth/:code, use it
            const fullPath = window.location.pathname || '';
            const authMatch = fullPath.match(/^\/driver\/auth\/([0-9A-Za-z]{8})$/);
            if (!codeParam && authMatch && authMatch[1]) {
                axios.defaults.withCredentials = true;
                const respA = await axios.post(`${API_ROOT}/driver/auth`, {code: authMatch[1]}, {withCredentials: true});
                if (respA && respA.status === 200) {
                    this.userHasAuthenticated(true);
                    await this.loadDriverProfile();
                    this.setState({isAuthenticating: false});
                    try {
                        window.history.replaceState({}, '', '/trips/create');
                    } catch (e) {
                    }
                    return;
                }
            }

            // Fallback 2b: if path contains 8-char code (e.g. /ABCDEFGH), use it
            const pathSeg = (window.location.pathname || '').split('/')[1] || '';
            if (!codeParam && pathSeg && pathSeg.length === 8) {
                axios.defaults.withCredentials = true;
                const resp2 = await axios.post(`${API_ROOT}/driver/auth`, {code: pathSeg}, {withCredentials: true});
                if (resp2 && resp2.status === 200) {
                    this.userHasAuthenticated(true);
                    await this.loadDriverProfile();
                    this.setState({isAuthenticating: false});
                    try {
                        window.history.replaceState({}, '', '/trips/create');
                    } catch (e) {
                    }
                    return;
                }
            }
            // Fallback 3: if referrer contains 8-char code, use it
            const ref = document && document.referrer || '';
            if (!codeParam && ref && ref.indexOf('driver.ghtranspo.com') !== -1) {
                const m = ref.replace(/\/$/, '').split('/').pop();
                if (m && m.length === 8) {
                    axios.defaults.withCredentials = true;
                    const resp3 = await axios.post(`${API_ROOT}/driver/auth`, {code: m}, {withCredentials: true});
                    if (resp3 && resp3.status === 200) {
                        this.userHasAuthenticated(true);
                        await this.loadDriverProfile();
                        this.setState({isAuthenticating: false});
                        try {
                            window.history.replaceState({}, '', '/trips/create');
                        } catch (e) {
                        }
                        return;
                    }
                }
            }
        } catch (e) {
            // ignore
        }

        // If driver portal cookie is present, treat as authenticated and promote to server session
        const driverIdCookie = Cookies.get('driver_id');
        if (driverIdCookie) {
            this.userHasAuthenticated(true);
            try {
                axios.defaults.withCredentials = true;
                await axios.post(`${API_ROOT}/driver/promote`, {driver_id: parseInt(driverIdCookie, 10)}, {withCredentials: true});
                await this.loadDriverProfile();
            } catch (e) {
            }
            this.setState({isAuthenticating: false});
            return;
        }

        // If no client cookie, check server session for driver login
        try {
            axios.defaults.withCredentials = true;
            const hb = await axios.get(`${API_ROOT}/driver/heartbeat`, {withCredentials: true});
            if (hb && hb.status === 200 && hb.data && hb.data.driver_id) {
                this.userHasAuthenticated(true);
                await this.loadDriverProfile();
                this.setState({isAuthenticating: false});
                return;
            }
        } catch (e) {
            // ignore, continue with staff flow checks below
        }

        if (typeof localStorage.getItem('permissions') != "undefined" && localStorage.getItem('permissions') != null && (localStorage.getItem('permissions').indexOf('DI') != -1 || localStorage.getItem('permissions') == "ALL")) {
            this.connectWebSocket();
        }

        if (localStorage.getItem('first_name') !== null) {
            axios.defaults.withCredentials = true;
            axios.post(`${API_ROOT}/heartbeat`, {withCredentials: true})
                .then(function (response) {
                    self.userHasAuthenticated(true);
                    self.setState({isAuthenticating: false});
                    self.refresh_from_local()
                    self.report_location();
                })
                .catch(function (error) {
                    self.setState({isAuthenticating: false});
                });
        } else {
            this.setState({isAuthenticating: false});
        }

        // send current location
        setInterval(async () => {
            this.report_location();
        }, 60 * 1000);

        setInterval(async () => {
            if (this.state.num_unread > 0) {
                document.title = "(" + this.state.num_unread + ") " + document.title.replace(/^\([^)]*\)\s*/, '');
            } else {
                document.title = document.title.replace(/^\([^)]*\)\s*/, '');
            }
        }, 1000);
    }


    report_location() {
        if (this.state.isAuthenticated == true) {
            /*Geolocation.getCurrentPosition(
                (position) => {
                    var coords = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        speed: position.coords.speed,
                        accuracy: position.coords.accuracy,
                    };
                    axios.defaults.withCredentials = true;
                    axios.post(`${API_ROOT}/ping`, {coords})
                        .catch(function (error) {
                        });
                },
                (error) => {
                    // See error code charts below.
                    console.log(error.code, error.message);
                },
                {enableHighAccuracy: true, timeout: 15000, maximumAge: 10000}
            );*/
        }
    }

    refresh_from_local() {
        this.setState({
            first_name: localStorage.getItem('first_name'),
            last_name: localStorage.getItem('last_name'),
            role_id: localStorage.getItem('role_id'),
            permissions: localStorage.getItem('permissions'),
            companies: localStorage.getItem('companies'),
        });
    }

    userHasAuthenticated = authenticated => {
        this.setState({isAuthenticated: authenticated});
    }
    userSignOut = event => {
        axios.defaults.withCredentials = true;
        axios.post(`${API_ROOT}/logout`, {withCredentials: true})
        localStorage.removeItem('first_name');
        localStorage.removeItem('last_name');
        localStorage.removeItem('role_id');
        localStorage.removeItem('permissions');
        localStorage.removeItem('companies');
        localStorage.removeItem('gh_driver_trip_draft');
        Cookies.remove('driver_id');
        this.userHasAuthenticated(false);
    }

    render() {

        // specify base href from env varible 'WP_BASE_HREF'
        // use only if application isn't served from the root
        // for development it is forced to root only
        /* global WP_BASE_HREF */
        const basename = '/';

        const childProps = {
            isAuthenticated: this.state.isAuthenticated,
            userHasAuthenticated: this.userHasAuthenticated,
            userSignOut: this.userSignOut,
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            role_id: this.state.role_id,
            refresh_from_local: this.refresh_from_local,
            num_unread: this.state.num_unread,
            num_unread_maint: this.state.num_unread_maint,
            messages: this.state.messages,
            messages_maint: this.state.messages_maint,
            last_updated_thread: this.state.last_updated_thread,
            last_updated_hash: this.state.last_updated_hash,
        };


        return (
            !this.state.isAuthenticating &&
            <BrowserRouter basename={basename}>
                <Routes childProps={childProps}/>
            </BrowserRouter>
        );
    }
}

export default App;
